export enum MENU {
  /**
   * 客户账户
   */
  CUSTOMER_ACCOUNT = 'customer-account',

  /**
   * 小票
   */
  RECEIPT = 'receipt',

  /**
   * 预约服务
   */
  SUBSCRIBE_SERVICE = 'subscribe-service',

  /**
   * 现场服务
   */
  SITE_SERVICE = 'site-service',

  /**
   * 兑换管理
   */
  EXCHANGE = 'exchange',

  /**
   * 特卖入场
   */
  SPECIAL_SALE = 'special-sale',

  /**
   * iguru
   */
   IGURU = 'iguru'
}

export const MENU_MAP = {
  [MENU.CUSTOMER_ACCOUNT]: '客户账户',
  [MENU.RECEIPT]: '小票',
  [MENU.SUBSCRIBE_SERVICE]: '预约服务',
  [MENU.SITE_SERVICE]: '现场服务',
  [MENU.EXCHANGE]: '兑换管理',
  [MENU.SPECIAL_SALE]: '特卖入场',
  [MENU.IGURU]: 'Iguru',
}
